<template>
  <div class="expand-row">
    <Table :data="rows" :columns="dangerArr" size="small" border ref="table">
     <template slot-scope="{ row }" slot="index">
      {{row._index+1}}
    </template>
      <template slot-scope="{ row }" slot="action">
        <Button type="primary" size="small" @click="$router.push('/examinationBank/questionBank?id='+row.id+'&name='+row.name)">题库</Button>
        <Button type="primary" size="small" @click="$router.push('/examinationBank/paperLibrary?id='+row.id+'&name='+row.name)">试卷库</Button>
      </template>
    </Table>
  </div>
</template>
<script>
export default {
  props: {
    rows: Array,
  },
  data() {
    return {
      dangerArr: [
       { title: "序号", slot: "index", maxWidth:80,align: "center"},
        { title: "章节名称",  minWidth:180,key: "name", align: "center" },
        { title: "题库数量", key: "question_storage_num", align: "center" },
        { title: "试卷库数量", key: "exam_paper_storage_num", align: "center" },
        { title: "操作", slot: "action", align: "center" },
      ],
    };
  },
  activated() {},
  methods: {
  },
};
</script>
<style scoped>
.group-name:nth-child(n + 2)::before {
  content: " / ";
}
</style>
